import { APP_VERSION } from "@/lib/app-version";
import { crmBaseUrl } from "@/lib/vybe-auth/api";

import type { UpdatesAdapter } from "../types";

/** "1.2.10" > "1.2.9" — numeric per-segment compare (missing segments = 0). */
function isNewer(candidate: string, current: string): boolean {
  const a = candidate.split(".").map(Number);
  const b = current.split(".").map(Number);
  for (let i = 0; i < Math.max(a.length, b.length); i++) {
    const d = (a[i] || 0) - (b[i] || 0);
    if (d !== 0) return d > 0;
  }
  return false;
}

/**
 * Web auto-update: poll the same CRM feed the desktop updater uses and compare
 * against the APP_VERSION baked into this bundle at build time. "Staging" is free
 * on web — applying is just a reload, which picks up the newly deployed SPA.
 */
export const webUpdatesAdapter: UpdatesAdapter = {
  applyLabel: "Reload",
  async checkAndStage() {
    const base = crmBaseUrl();
    if (!base) return null;
    try {
      const res = await fetch(`${base.replace(/\/$/, "")}/downloads/latest.json`, {
        cache: "no-store",
      });
      if (!res.ok) return null;
      const feed = (await res.json()) as { version?: string };
      return feed.version && isNewer(feed.version, APP_VERSION)
        ? { version: feed.version }
        : null;
    } catch {
      return null;
    }
  },
  apply: () => window.location.reload(),
};
